import React, { useContext } from 'react';
import { Context } from 'components/Store';
import GrowUIFormField from 'components/Forms/GrowUIFormField';
import { Input } from '@agconnections/grow-ui';
import { useFormikContext } from 'formik';

const Slope = () => {
  const [{ isEnableInfoTabEdit }] = useContext(Context);
  const { setFieldValue } = useFormikContext();

  return (
    <GrowUIFormField
      control={Input}
      type="text"
      id="slope"
      name="slope"
      label="Slope Percentage"
      disabled={!isEnableInfoTabEdit}
      placeholder="Enter slope percentage"
      onChange={e => setFieldValue('slope', e.target.value)}
    />
  );
};

export default Slope;
